import React from 'react'
import type { AnchorHTMLAttributes } from 'react'
import { Button } from './button'

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  leadingIcon?: React.ElementType
  trailingIcon?: React.ElementType
}

export function Link({
  leadingIcon,
  trailingIcon,
  children,
  ...props
}: LinkProps) {
  return (
    <Button
      as="a"
      variant="link"
      size={'md'}
      leadingIcon={leadingIcon}
      trailingIcon={trailingIcon}
      {...(props as object)}
    >
      {children}
    </Button>
  )
}
